import { Dialog } from "@mui/material";

export const MuiDialog = Dialog;
